module.exports = __webpack_public_path__ + "img/twitter.99a96d4e.png";